import { PropsWithChildren, ReactNode } from 'react';

import cardRecipe, { CardRecipeProps } from './card.styles';
import { cx } from '@/utils/cx';

type CardMediaProps = {
    className?: string;
    children?: ReactNode;
    ariaLabel?: string;
} & CardRecipeProps;

const CardMedia = ({
    className,
    children,
    ariaLabel,
    ...rest
}: PropsWithChildren<CardMediaProps>) => {
    const [variantProps, localProps] = cardRecipe.splitVariantProps(rest);
    const recipeClassNames = cardRecipe(variantProps);

    return (
        <div
            className={cx(recipeClassNames.media, className)}
            aria-label={ariaLabel}
            {...localProps}>
            {children}
        </div>
    );
};

export { CardMedia };
export type { CardMediaProps };
